import request from "../http/request";
//调用微信sdk
export function getAuthInfo(params) {
  return request({
    url: "/api/wechat/wachat/page/auth",
    method: "get",
    params,
  });
}

// 上传进件图片并调用原进件接口
export function uploadImageAndCall(data) {
  return request({
    url: "/api/merchant/app/merchant/register/record/register/with-images",
    method: "post",
    data,
    isMessage: true,
  });
}

// 根据id获取进件记录详情
export function getRegisterDetail(params) {
  return request({
    url: "/api/merchant/app/merchant/register/record/detail",
    method: "get",
    params,
    isMessage: true,
  });
}
